import { useAtom } from 'jotai';
import { domain } from 'modules/data';
import { memo, useCallback } from 'react';
import { useSyncQBooksBudgets } from 'shared/data/webApp/v2';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { syncQBooksBudgetsPageState } from '../../states';
import SyncNowButton from '../SyncBudgetButton/SyncBudgetButton';
import { messages } from './QBooksSyncBudgetButton.messages';
import { QBooksSyncBudgetButtonProps } from './QBooksSyncBudgetButton.types';

export const QBooksSyncBudgetButton = memo<QBooksSyncBudgetButtonProps>((props) => {
    const { isBudgetSyncEnabled, isSyncInProgress = false } = props;

    const company = useCompanyBasedOnUrl();

    const [syncQBooksBudgetsState, setSyncQBooksBudgetsState] = useAtom(syncQBooksBudgetsPageState);

    const { mutate: syncQBooksBudgets, isLoading: isLoadingSyncQBooksBudgets } = useSyncQBooksBudgets({
        onSuccess: () => {
            setSyncQBooksBudgetsState(true);
        },
    });

    const syncBudget = useCallback(() => {
        syncQBooksBudgets({
            params: {
                path: {
                    companyId: company.id,
                },
            },
        });
    }, [syncQBooksBudgets, company.id]);

    return (
        <SyncNowButton
            disabled={company.isReadonly || syncQBooksBudgetsState || isSyncInProgress || !isBudgetSyncEnabled}
            integrationType={domain.IntegrationType.QBooks}
            syncBudget={syncBudget}
            isLoading={isLoadingSyncQBooksBudgets}
            isBudgetSyncEnabled
            title={!isBudgetSyncEnabled ? messages.syncIsDisabled : undefined}
        />
    );
});

QBooksSyncBudgetButton.displayName = 'QBooksSyncBudgetButton';
